import { render, staticRenderFns } from "./MaterialSettings.vue?vue&type=template&id=6197d521"
import script from "./MaterialSettings.vue?vue&type=script&lang=ts"
export * from "./MaterialSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports